import config from '../../config';
import React from 'react';
import {FETCH_ALL_CONTRACTORS_LIST, FETCH_ALL_SELLERS_LIST, UPDATE_CUSTOM_USER_DATA} from "actions/actionTypes";
import {convertToHoursAndMinutes} from 'util/Utils';
import queryString from 'query-string'
import Switch from "react-switch";
import _ from "lodash";
import moment from 'moment'

export function fetchAllSellersList(){
    if (_.size(this.props.allSellersList.data) == 0) {
        var methodData = {
            "success_event": FETCH_ALL_SELLERS_LIST,
            "endpoint": "/sellers",
            'not_display_success_message': true
        };
       return  this.props.makeRequest({sortBy:'DisplayName:1',all:true, include:['DisplayName' ]}, methodData).catch(err => {
        });
    }
}
export function  resetTrackedTime() {

    var seconds = config.getEnvironmentName() == 'local' ? 20 : 120
    this.setState({pending: false, currentTimeTracked: ''})
    clearInterval(this.intervalID);
    this.props.dispatchAction({
        timeTrackingStarted: false,
        activityLastTrackedAt: false,
        timeTrackingRecordID:false,
        pending: false,
        activityType: '',
        pendingUserAction: false,
        displayTimeTrackingPromptAfter: moment().add(seconds, 'seconds').toISOString(),
        ProductsAdded: [],
    }, UPDATE_CUSTOM_USER_DATA)
    //  this.props.dispatchAction({'timeTrackingAction':'stopped'}, TIME_TRACKING_CHANGED)
}
export function fetchCurrentContractorRecord(){
    console.log('fetchCurrentContractorRecord'  );
    var self = this;
     if (_.get(this.props, ['userReducer','contractor', '_id'], false) && _.get(this.props, ['userReducer','contractor', 'Status']) =='Active'){
        var methodData = {
             "endpoint": "/users_data",
            'not_display_success_message': true
        };
      return  this.props.makeRequest({Statuses:['CurrentlyTracked'],ContractorID: _.get(this.props, ['userReducer','contractor', '_id'], false)  }, methodData).then(response=>{
        console.log('StartTime', _.get(response.data.data, [0,'StartTime'])  );
        if (_.get(this.props.userReducer, 'customUserData.timeTrackingRecordID')  ){
            if( _.get(this.props.userReducer, 'customUserData.timeTrackingRecordID') ==_.get(response.data.data, [0,'_id'])){
                console.log('the same'   );
                return
            }else{
                console.log('not the same' , _.get(this.props.userReducer, 'customUserData')  );
                var activityTypeLabel = _.get(_.find(config.timeTrackingActivityData, item=>{
                    return item.name ==    _.get(this.props.userReducer, 'customUserData.activityType')
                }), 'comment','Not found')
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Time tracking for ' + activityTypeLabel + ' was already saved'
                });
                if (!_.get(response.data.data, [0,'_id']) ) {/* if there is no new record*/
                  return  resetTrackedTime.call(self)
                }
            }

        }
            if (_.get(response.data.data, [0,'_id']) ) {
              var customUserData = {
                  timeTrackingRecordID:_.get(response.data.data, [0,'_id']),
                  timeTrackingStarted: _.get(response.data.data, [0,'StartTime']),
                  activityLastTrackedAt: moment().toISOString(),
                  LastRefreshedAt: moment().toISOString(),
                  pendingUserAction: false,
                  doNotShowChangeActivityModal:false,
                  previousActivityType:'',
                  displayTimeTrackingPromptAfter: false,
                  ProductsAdded: [],

                  activityType:_.get(response.data.data, [0,'ActivityType'])
              }
              console.log('customUserData', customUserData  );
              self.props.dispatchAction(customUserData, UPDATE_CUSTOM_USER_DATA)
                startTimeTrackingEvent.call(self, _.get(response.data.data, [0,'_id']))
          }
      }).catch(err => {
          return Promise.reject(err)
        });
    }
}
export function fetchAllContractorsList(){
    if (_.size(this.props.allContractorsList.data) == 0) {
        var methodData = {
            "success_event": FETCH_ALL_CONTRACTORS_LIST,
            "endpoint": "/contractors",
            'not_display_success_message': true
        };
        this.props.makeRequest({sortBy:'UserFullName:1',all:true, fieldsToAdd:['UserFullName']}, methodData).catch(err => {

        });
    }
}
export function  getScheduledServices(params) {
    var self = this;
    var methodData = {
        'endpoint': '/get-scheduled-services',
        'type': 'post',
        'not_display_success_message': true,
    };
    params.StatusesToExclude =['Cancelled']
    this.props.makeRequest(params, methodData).then(res => {
        var PickupsByDate = _.groupBy(res.data.ScheduledPickups, function (selectedPickup) {
            return self.moment(selectedPickup.ServiceStartTime).format('MM-DD')

        })
        var DropoffsByDate = _.groupBy(res.data.ScheduledDropoffs, function (selectedPickup) {
            return self.moment(selectedPickup.ServiceStartTime).format('MM-DD')

        })
        var PickupsByDateAndServiceAreas = []
        _.forEach(PickupsByDate, function (pickupsByDate, date) {
            PickupsByDateAndServiceAreas[date] = _.groupBy(pickupsByDate, function (pickup) {
                return pickup.ServiceAreaID

            })
        })
        self.setState({
            ScheduledPickups: PickupsByDateAndServiceAreas,
            ScheduledDropoffs: DropoffsByDate,
        });
    })
}
export function  getVariationOptions(variaiton, sortOrder='asc') {
    var customOptions = []
    switch (variaiton.Label) {
        case 'year':
            customOptions.push({
                value: moment().format('Y'),
                label: moment().format('Y')
            })
            for (var i = 1; i < 20; i++) {
                customOptions.push({
                    value: moment().subtract(i, 'years').format('Y'),
                    label: moment().subtract(i, 'years').format('Y'),
                })
            }
            break;
        default:
              customOptions = _.orderBy(variaiton.Options, 'label',sortOrder)
    }
    return customOptions


}

export function fetchSettings(settingsName) {
    var methodData = {
        "endpoint": "/settings",
         'not_display_error_message': true,
        }
    return this.props.makeRequest({ Name: settingsName}, methodData).then(function (res) {
         return  res.data.data[0].Data;
    }).catch(err => {
      return Promise.reject(err);
    });
}

export function fetchServiceSettings(params = {}) {
    return new Promise((resolve, reject) => {
        console.log('fetchServiceSettings', params  );
        var self = this

         this.props.makeRequest({Name:params.MarketName + 'ServiceSettings'}, {
            "endpoint": "/settings",
            'not_display_error_message': true,

        }).then(function (res) {
            var settingsRecord = _.get(res.data.data,[0,'Data'],{})
           const {Pickup = {}, Dropoff= {}} =  settingsRecord
             var display_type = _.get(this.props, ['location', 'query', 'display_type'],'')
              if(!display_type && _.size(_.get(settingsRecord, ['Pickup', 'ConfigurationsToDisplay'], []))) {
                 var rand=_.random(0,1)
                  display_type = _.get(settingsRecord, ['Pickup', 'ConfigurationsToDisplay', rand], '')
              }
              console.log('display_type', display_type  );
              var pickupScreensData =   _.unionBy(_.get(settingsRecord, ['Pickup','ScreensData_'+ display_type],[]),  _.get(settingsRecord, ['Pickup','ScreensData'], []), "ScreenName");
              var dropoffScreensData =   _.unionBy(_.get(settingsRecord, ['Dropoff','ScreensData_'+ display_type],[]),  _.get(settingsRecord, ['Dropoff','ScreensData'], []), "ScreenName");
             //  var maximumPickupSizeNumberForDate = _.find(_.get(settingsRecord, 'Pickup.maximumSizeNumberForDayByDates', []), function (rule) {
             //          return self.moment(rule.Date).isSame(self.moment(),'day')
             //     })
             //  var maximumDropoffSizeNumberForDate = _.find(_.get(settingsRecord, 'Dropoff.maximumSizeNumberForDayByDates', []), function (rule) {
             //     return self.moment(rule.Date).isSame(self.moment(),'day')
             // })


               this.orderData = {
                  display_type:display_type,
                  CommonServiceData:   this.orderData.CommonServiceData,
                ServiceStatus:_.get(settingsRecord, 'ServiceStatus'),

                ServiceSettingsForLocation:params.MarketName,
                'Pickup': {
                    ServiceStatus:_.get(settingsRecord, 'Pickup.ServiceStatus'),
                    FeeAmount:_.get(settingsRecord, 'Pickup.FeeAmount'),
                    bookNotEarlierThanDaysNumber:_.get(settingsRecord, 'Pickup.bookNotEarlierThanDaysNumber'),
                    bookNotEarlierThanDaysForMonday: Pickup.bookNotEarlierThanDaysForMonday,
                    bookNotLaterThanTimeForMonday: Pickup.bookNotLaterThanTimeForMonday,
                    bookNotLaterThanTime: Pickup.bookNotLaterThanTime,
                    maximumDaysNumberToAllowBooking:_.get(settingsRecord, 'Pickup.maximumDaysNumberToAllowBooking',21),
                    maximumSizeNumberForTimeSlot: _.get(settingsRecord, 'Pickup.maximumSizeNumberForTimeSlot', 8),
                    // maximumSizeNumberForDay : maximumPickupSizeNumberForDate ? maximumPickupSizeNumberForDate.value :_.get(_.find(_.get(settingsRecord, 'Pickup.maximumSizeNumberForDay', []), item=>{
                    //              return  _.get(item,'dayOfWeek') ==self.moment().format('dddd')
                    //     }), 'value',18),
                   'timeWindowOptions': _.map(_.get(settingsRecord, 'Pickup.timeWindowOptions', []), function (record) {
                       let disabled = false,  {DaysOfWeek =[]}=record
                       if(!_.isUndefined(record.DaysOfWeek) && DaysOfWeek.length==0){
                         disabled = true;
                        }
                       return {...record, disabled: disabled}
                    }),
                    ScreensData: pickupScreensData,
                    SettingsData: _.pick( settingsRecord['Pickup'],['maximumSizeNumberForDayByDates','maximumSizeNumberForDay']),
                },
                'Mail In': {
                    ServiceStatus:_.get(settingsRecord, 'Dropoff.ServiceStatus'),
                    FeeAmount:_.get(settingsRecord, 'Dropoff.FeeAmount'),
                    bookNotEarlierThanDaysNumber:_.get(settingsRecord, 'Dropoff.bookNotEarlierThanDaysNumber'),
                    bookNotEarlierThanDaysForMonday:Dropoff.bookNotEarlierThanDaysForMonday,
                    bookNotLaterThanTimeForMonday:Dropoff.bookNotLaterThanTimeForMonday,
                    bookNotLaterThanTime:Dropoff.bookNotLaterThanTime,
                    maximumDaysNumberToAllowBooking:_.get(settingsRecord, 'Dropoff.maximumDaysNumberToAllowBooking',21),
                    'timeWindowOptions': _.map(_.get(settingsRecord, 'Dropoff.timeWindowOptions', []), function (record) {
                        let disabled = false,  {DaysOfWeek =[]}=record
                        if(!_.isUndefined(record.DaysOfWeek) && DaysOfWeek.length==0){
                            disabled = true;
                        }
                        return {...record, disabled: disabled}
                    }),
                    DaysOfWeek: _.get(settingsRecord, 'Dropoff.DaysOfWeek', []),
                    SettingsData: _.pick(settingsRecord['Dropoff'],['maximumSizeNumberForDayByDates','maximumSizeNumberForDay']),
                    ScreensData: dropoffScreensData                    
                },
                'Dropoff': {
                    ServiceStatus:_.get(settingsRecord, 'Dropoff.ServiceStatus'),
                    FeeAmount:_.get(settingsRecord, 'Dropoff.FeeAmount'),
                    bookNotEarlierThanDaysNumber:_.get(settingsRecord, 'Dropoff.bookNotEarlierThanDaysNumber'),
                    bookNotEarlierThanDaysForMonday:Dropoff.bookNotEarlierThanDaysForMonday,
                     bookNotLaterThanTimeForMonday:Dropoff.bookNotLaterThanTimeForMonday,
                    bookNotLaterThanTime:Dropoff.bookNotLaterThanTime,
                     maximumDaysNumberToAllowBooking:_.get(settingsRecord, 'Dropoff.maximumDaysNumberToAllowBooking',21),
                     'timeWindowOptions': _.map(_.get(settingsRecord, 'Dropoff.timeWindowOptions', []), function (record) {
                        let disabled = false,  {DaysOfWeek =[]}=record
                        if(!_.isUndefined(record.DaysOfWeek) && DaysOfWeek.length==0){
                            disabled = true;
                        }
                        return {...record, disabled: disabled}
                    }),
                    //  maximumSizeNumberForDay : maximumDropoffSizeNumberForDate? maximumDropoffSizeNumberForDate.value:_.get(_.find(_.get(settingsRecord, 'Dropoff.maximumSizeNumberForDay', []), item=>{
                    //      return  _.get(item,'dayOfWeek') ==this.moment().format('dddd')
                    // }), 'value',12),

                    DaysOfWeek: _.get(settingsRecord, 'Dropoff.DaysOfWeek', []),
                     SettingsData: _.pick(settingsRecord['Dropoff'],['maximumSizeNumberForDayByDates','maximumSizeNumberForDay']),
                    ScreensData: dropoffScreensData
                }
            }

            this.setState({})
            this.orderDataOriginal = _.cloneDeep(this.orderData)
             resolve( )

        }.bind(this)).catch(err => {
            console.log('err', err  );
            resolve( )
        });
    })
}


export function saveTimeTrackingLog(  params) {
    return new Promise((resolve, reject) => {
        var self = this;
        console.log('saveTimeTrackingLog', params  );
        // if (config.getEnvironmentName() == 'production'){ /* disableTimeTracking */
        //     return;
        // }
        var userReducerState = self.props.getCurrentStoreState().userReducer
console.log('userReducerState', userReducerState  );
        var activityLastTrackedAt = _.get(userReducerState, 'customUserData.activityLastTrackedAt') ? moment(_.get(userReducerState, 'customUserData.activityLastTrackedAt')) : moment()

        var timeTrackingStarted = moment(userReducerState.customUserData.timeTrackingStarted)
        console.log('timeTrackingStarted', timeTrackingStarted  );
        var durationInSeconds = moment().diff(timeTrackingStarted, 'seconds')


        var minutes = Math.floor(durationInSeconds / 60);
        var remainderSeconds = durationInSeconds % 60

        if (remainderSeconds > 30) {
            minutes++
        }
        var customUserDataToUpdate = {
            timeTrackingStarted: false,
            activityLastTrackedAt: false,
            timeTrackingRecordID:false,
            previousActivityType: '',
            activityType: '',
            pendingUserAction: false,
            displayTimeTrackingPromptAfter: moment().add(config.getEnvironmentName() == 'local' ? 20 : 120, 'seconds').toISOString(),
            ProductsAdded: [],
        }
        console.log('minutes plus reminder', minutes);
        if (minutes >= 1440) {
            self.props.dispatchAction(customUserDataToUpdate, UPDATE_CUSTOM_USER_DATA)
            self.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Sorry, time can not be longer than  24 hours. Please, add time record manually'
            });
            removeTimeTrackingRecord.call(self,userReducerState)
            return reject()
        }
        if (config.getEnvironmentName() !== 'local' && minutes == 0) {

            self.props.dispatchAction(customUserDataToUpdate, UPDATE_CUSTOM_USER_DATA)
            if (_.isUndefined(params.doNotDisplayMessage)) {
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Time log should be at least 1 minute'
                });
                return reject()
            } else {
                /* when user changes activity using popup modal*/
                return resolve()
            }

        }

        var workEndTime = moment(userReducerState.customUserData.timeTrackingStarted).add(minutes, 'minutes')
        console.log('start', timeTrackingStarted.format('HH:mm ss'));
        console.log('workEndTime', workEndTime.format('HH:mm ss'));
        var dataToUpdate = {
            EndTime: workEndTime,
            Comment:   _.get(_.find(config.timeTrackingActivityData, {name: _.get(userReducerState.customUserData, 'activityType')}), 'comment', 'activity n/a'),
            Status: 'Pending',
            CustomData: {
                LastRefreshedAt: moment().toISOString(),
                SavedFrom:'website',
            }
        }
        if (!_.includes(["Fulfillment", "CustomerService", "Driving", "Meeting", "Other", "PuttingAway"], userReducerState.customUserData.activityType)) {
            dataToUpdate.ProductsAdded = userReducerState.customUserData.ProductsAdded
        }
       self.props.makeRequest(dataToUpdate, {
            'endpoint': '/users_data/' + encodeURIComponent(userReducerState.customUserData.timeTrackingRecordID),
            timeout: 39000,
            'type': 'patch',
        }).then(function (response) {
            console.log('code', _.get(response, 'data.code')  );
            if (_.includes(['time_tracking_record_already_saved','time_tracking_record_removed'],_.get(response, 'data.code')) ) { /* if it is already saved or does not exist for some reason, stop current time tracking */
               var messageToDisplay = 'Time tracking was already saved'
                if(_.get(response, 'data.timeTrackingRecord.CustomData.SavedFrom')){
                     if(_.get(response, 'data.timeTrackingRecord.CustomData.SavedFrom') == 'mobile_app'){
                        messageToDisplay += ' in the mobile app'
                    }else if(_.get(response, 'data.timeTrackingRecord.CustomData.SavedFrom') == 'website'){
                        messageToDisplay += ' on the website'
                    }else if(_.get(response, 'data.timeTrackingRecord.CustomData.SavedFrom') == 'server'){
                    messageToDisplay = 'Time tracking was already auto saved'
                     }
                }
                if(_.get(response, 'data.clientMessageToDisplay')){
                    messageToDisplay =_.get(response, 'data.clientMessageToDisplay')
                }
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode':messageToDisplay
                });
                console.log('already saved'  );
                self.props.dispatchAction(customUserDataToUpdate, UPDATE_CUSTOM_USER_DATA)
            } else {
                if (_.isUndefined(params.doNotDisplayMessage)) {
                    self.props.displayMessage({

                        'messageCode': 'Time tracking record saved'
                    });
                }

                self.props.dispatchAction(customUserDataToUpdate, UPDATE_CUSTOM_USER_DATA)
            }

            return resolve(response)
        }).catch(function (err) {

            console.log('err', err);
            return reject()
        })
    })
}
function removeTimeTrackingRecord(userReducerState){

    this.props.makeRequest({}, {
        'endpoint': '/users_data/' + encodeURIComponent(userReducerState.customUserData.timeTrackingRecordID),
        timeout: 39000,
        'type': 'delete',
    }).then(function (response) {
        console.log('remove', _.get(response, 'data.code')  );
    }).catch(function (err) {
       console.log('err', err);

    })
}
export  function  stopAndStartTimeTracking(params) {
    return new Promise((resolve, reject) => {
        var self = this;
        console.log('stopAndStartTimeTracking');
        saveTimeTrackingLog.call(self, {
            doNotDisplayMessage: true,
            type: 'stoppedByUser'
        }).then(() => {

            // checkExpectedTimeAndStartTimeTracking.call(self, {
            //     activityExpectedTime:self.state.activityExpectedTime,
            //     activityType:  activityType
            // })
            self.setState({
                activityType: '',
                activityExpectedTimeModalVisible: false,
                activitiesListModalVisible: false,
                activityExpectedTime: ''
            }, () => {
                console.log('initiateTimeTracking', params);
                initiateTimeTracking.call(self, params)
                resolve()
            })

        }).catch(e => {

            console.log('error 1', e);
            reject(e)
        })
    })

}


function tick(customUserData) {
    this.setState({
        currentTimeTracked: moment.utc(moment().diff(moment(customUserData.timeTrackingStarted))).format("HH:mm:ss")
    });
}
function startTimeTrackingIntervalMethod(customUserData) {
    console.log('startTimeTrackingInterval', customUserData)
    var self = this;
    console.log('self', self  );
    tick.call(self,customUserData)
    self.intervalID = setInterval(
        () => tick.call(self,customUserData),
        1000
    );
}
export var startTimeTrackingInterval =   _.throttle(startTimeTrackingIntervalMethod, 1500, {
    /* to not trigger startTimeTrackingInterval two times (one of them in willReceiveProps) when user presses on Start button */
    'leading': true,
    'trailing': false
});
export function startTimeTrackingByUser(params) {
    var self = this;
    if (_.get(this.props.userReducer, 'contractor._id')) {
        console.log('current type', _.get(this.props.userReducer, 'customUserData.activityType'));
        if (_.get(this.props.userReducer, 'customUserData.timeTrackingStarted')) {
            //   if (_.get(this.props.getCurrentStoreState().userReducer, 'customUserData.activityType') !== activityType) {

            // var data = {activityType: activityType}
            // if (_.get(this.props.getCurrentStoreState().userReducer, 'customUserData.activityType') == 'CustomerService') {
            //     data.previousActivityType = _.get(this.props.getCurrentStoreState().userReducer, 'customUserData.activityType')
            // }
            // console.log('data', data);
            //   stopAndStartTimeTracking.call(self, data)

            //   }
        } else {
            if (config.getEnvironmentName() !== 'local1') {
                startTimeTracking.call(self, params)
            }
            console.log('start activity',);
            if (config.getEnvironmentName() !== 'local') {
                return;
            }
        }

    }
}
function  initiateTimeTracking(params) {
    var self = this;

    self.setState({
        activityType: '',
        activityExpectedTimeModalVisible: false,
        activitiesListModalVisible: false,
        activityExpectedTime: ''
    }, () => {
        setTimeout(() => {
            startTimeTracking.call(self, params)
            console.log('initiateTimeTracking');
            if (self.state.timeTrackingActivityStartedCallback) {
                self.state.timeTrackingActivityStartedCallback()
                self.setState({
                    timeTrackingActivityStartedCallback: false
                })
            }
            // displayMessage({
            //     'messageCode': 'Time tracking has started'
            // });
            setTimeout(() => {
                self.displayStartTrackingTimePending = false;
            }, 1000)
        }, 1)
    })
}

export function startTimeTracking(params) {
console.log('startTimeTracking', params  );
    if(config.getEnvironmentName() == 'local1'){
        return  true
    }
    var self = this;
    var userReducerState = self.props.getCurrentStoreState().userReducer
    if (!_.get(userReducerState, 'user._id', false) || _.get(userReducerState, 'customUserData.timeTrackingStarted')) { /* if time tracker is already started*/
        return
    }

    var customUserData = {
        timeTrackingStarted: moment().toISOString(),
        activityLastTrackedAt: moment().toISOString(),
        LastRefreshedAt: moment().toISOString(),
        pendingUserAction: false,
        doNotShowChangeActivityModal:false,
        previousActivityType:_.get(params, 'previousActivityType',''),
        displayTimeTrackingPromptAfter: false,
        ProductsAdded: [],
        timeTrackingRecordID: false,
        activityType: params.activityType,
    }

    if(params.activityExpectedTime){
        customUserData.expectedWorkingTimeEndAt =moment().add(params.activityExpectedTime,_.includes(['production','development'],config.getEnvironmentName())  ? 'hours' : 'minutes').toISOString()
        console.log('new working time ', customUserData.expectedWorkingTimeEndAt  );
    }

    var dataToSave = {
        ContractorID: userReducerState.contractor._id,
        StartTime: customUserData.timeTrackingStarted,
        ActivityType: params.activityType,
        Status: 'CurrentlyTracked',
        Type: 'WorkingTime',
    }
    //  if (_.includes(["Fulfillment", "CustomerService", "Driving", "Meeting", "Other","PuttingAway"], params.activityType)) {
    if(params.activityExpectedTime) {
        var durationObject = moment.duration({
            [_.includes(['production', 'development'], config.getEnvironmentName()) ? 'hours' : 'hours']: params.activityExpectedTime,
        })

        var milliseconds = durationObject.asMilliseconds()
    }else if(_.get(self.props.userReducer, [ 'customUserData','expectedWorkingTimeEndAt'])){

        milliseconds =moment(_.get(self.props.userReducer, [ 'customUserData','expectedWorkingTimeEndAt'])).diff(moment(), 'milliseconds')
        console.log('existing working time ', milliseconds );
    }
    //   milliseconds = milliseconds +  (_.includes(['production','development'],config.getEnvironmentName())   ? 3600000 : 60000 )
    /* add 1 hour */
    if(milliseconds >0) {
        dataToSave.StopActivityReminderTimeout = milliseconds
    }
    if(customUserData.previousActivityType == 'CustomerService' && dataToSave.ActivityType == 'PuttingAway' ) {
        _.extend(dataToSave,{
            notificationMessagePayload:{
                PushNotificationType:'ChangeTimeTrackingActivity',
                previousActivityTypeToResume:'CustomerService'
            },
            notificationMessageToDisplay : 'Would you like to return to Customer Service?',
            maximumInactivityPeriodSec : config.getEnvironmentName() == 'local1' ? 30 : 300,  /*  5 minutes*/
            StopActivityReminderTimeout : config.getEnvironmentName() == 'local1' ? 60000 :300000 , /* check in 660000 11 minutes as LastRefreshedAt is updated first time only in five minutes after starting a timer*/
            //  saveRecordTimeout : config.getEnvironmentName() == 'local1' ? 30000 : 60000, /* save in 1 minute*/
        })

    }
    console.log('dataToSave.StopActivityReminderTimeout', dataToSave.StopActivityReminderTimeout  );
    //  }
    // displayMessage({
    //     'messageType': 'warning',
    //     'messageCode': 'Send start time tracking'
    // });
    dataToSave.request_source = 'website'
    self.props.makeRequest(dataToSave, { /* in some cases throw error props.makeRequest is not a function in .1.33*/
        "endpoint": "/users_data",
        'type': 'post',
        timeout: 26000,
        'not_display_success_message': true
    }).then(response => {
        // displayMessage({
        //     'messageType': 'warning',
        //     'messageCode': 'Response start time tracking'
        // });
        console.log('startTimeTrackingByUser response.data',   response.data  );


            if(_.get(response.data,'code') =='another_time_tracking_already_running'){
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Another time tracking record for ' +_.startCase(response.data.currentlyTrackingRecord.ActivityType) + ' is already tracked for ' + convertToHoursAndMinutes( moment.duration(moment().diff(moment(response.data.currentlyTrackingRecord.createdAt))), {format: 'hours_minutes_seconds'})
                })
                  customUserData = {
                    timeTrackingRecordID:_.get(response.data.currentlyTrackingRecord, ['_id']),
                    timeTrackingStarted: _.get(response.data.currentlyTrackingRecord, ['StartTime']),
                    activityLastTrackedAt: moment().toISOString(),
                    LastRefreshedAt: moment().toISOString(),
                    pendingUserAction: false,
                    doNotShowChangeActivityModal:false,
                    previousActivityType:'',
                    displayTimeTrackingPromptAfter: false,
                    ProductsAdded: [],

                    activityType:_.get(response.data.currentlyTrackingRecord, ['ActivityType'])
                }
                startTimeTrackingEvent.call(self,response.data.currentlyTrackingRecord._id)
                self.props.dispatchAction(customUserData, UPDATE_CUSTOM_USER_DATA)
            }else    if (response.data._id) {
                customUserData.timeTrackingRecordID =response.data._id
                self.props.dispatchAction(customUserData, UPDATE_CUSTOM_USER_DATA)
                startTimeTrackingEvent.call(self, response.data._id)
            }


            // self.props.makeRequest({}, {
            //     "endpoint": "/check_user_tracking_time" + '/' + encodeURIComponent(this.state.currentRecord._id),
            //     type: "event-stream",
            // }).then(data => {
            //
            // }).catch(err => {
            //     console.log('err', err  );
            // });

    }).catch(err => {


    });

  //  self.props.dispatchAction(customUserData, UPDATE_CUSTOM_USER_DATA)

}
function  startTimeTrackingEvent(recordID) {
    var self = this;
    const stringified = queryString.stringify({timeTrackingRecordID:recordID});
    console.log('startTimeTrackingEvent', self.timeTrackingEventSource );
    if (self.timeTrackingEventSource){
        self.timeTrackingEventSource.close()
    }
    self.timeTrackingEventSource =  new EventSource(config.getEnvironment().serverBaseURL +'/check_user_tracking_time?' +stringified);
    console.log('self.timeTrackingEventSource 2', self.timeTrackingEventSource  );
    self.timeTrackingEventSource.addEventListener("closedConnection", e => {
        console.log('closedConnection'   );
        self.timeTrackingEventSource.close()
    })
    self.timeTrackingEventSource.addEventListener("timeTrackingRecordNotFound", event => {
        console.log('recordID', recordID,_.get(self.props.userReducer, 'customUserData.timeTrackingRecordID')  );

        var eventData =JSON.parse(_.get(event,'data',''))
        console.log('eventData', eventData  );

        if (_.get(self.props.userReducer, 'customUserData.timeTrackingRecordID') ==recordID) {
            var activityTypeLabel = _.get(_.find(config.timeTrackingActivityData, item => {
                return item.name == _.get(self.props.userReducer, 'customUserData.activityType')
            }), 'comment', 'Not found')
            var messageToDisplay = 'Time tracking for ' + activityTypeLabel + ' was already saved'
            if(_.get(eventData, 'SavedFrom')) {
                if (_.get(eventData, 'SavedFrom') == 'mobile_app') {
                    messageToDisplay += ' in the mobile app'
                } else if (_.get(eventData, 'SavedFrom') == 'website') {
                    messageToDisplay += ' on the website'
                } else if (_.get(eventData, 'SavedFrom') == 'server') {
                    messageToDisplay = 'Time tracking for ' + activityTypeLabel + ' was already auto saved'
                }
            }
            self.props.displayMessage({
                'messageType': 'warning',
                'messageCode': messageToDisplay
            });
            resetTrackedTime.call(self)
            fetchCurrentContractorRecord.call(self)
        }
    })
}
export function fetchDateRules(params) {
    return new Promise((resolve, reject) => {
         var self = this;
        this.props.makeRequest(_.pick(params, ['Name']), {
            "endpoint": "/settings",
            'not_display_error_message': true,

        }).then(function (res) {
            var settingsRecord = _.get(res.data.data,[0,'Data'],{})
                  self.setState({
                     PickupDateRules: _.map(_.get(settingsRecord, ['Pickup', 'Rules'], []), function (rule) {
                         return self.moment(rule.Date).format('MM-DD-YYYY')
                     }),
                    DropoffDateRules: _.map(_.get(settingsRecord, [ 'Dropoff', 'Rules'], []), function (rule) {
                        return self.moment(rule.Date).format('MM-DD-YYYY')
                    })}, function () {
                     resolve()
                })

        })
    })
}
export function checkValidDates(params) {
    params = _.defaults(params, {filterServiceAreas: false, user: 'user'})
    let daysNumber = 0;

  let bookNotEarlierThanDaysForMonday = 0
  let bookNotLaterThanTime

  const dateToCheck = this.moment(params.current)
  const dayOfWeekForDate = dateToCheck.day()
   if (this.state.administratorMode) {
    return true
  }
       if (params.user !== 'administrator') {
          daysNumber = this.orderData[this.state.ServiceType].bookNotEarlierThanDaysNumber
          bookNotLaterThanTime = this.orderData[this.state.ServiceType].bookNotLaterThanTime || '00-00'
          bookNotEarlierThanDaysForMonday = _.isUndefined(this.orderData[this.state.ServiceType].bookNotEarlierThanDaysForMonday) ? 3 : this.orderData[this.state.ServiceType].bookNotEarlierThanDaysForMonday

         if(dayOfWeekForDate == 1){
           if (this.moment().add(bookNotEarlierThanDaysForMonday, 'days').isAfter(dateToCheck, 'day')) {
             return false;
           }
           daysNumber = bookNotEarlierThanDaysForMonday
           bookNotLaterThanTime = this.orderData[this.state.ServiceType].bookNotLaterThanTimeForMonday  || '00-00' /* for Monday we use a separate time cut-off settings*/
         }
        if(bookNotLaterThanTime) {
        const time = this.moment(bookNotLaterThanTime, 'HH-mm');

        bookNotLaterThanTime = this.moment()
        bookNotLaterThanTime.set({
          hour: time.get('hour'),
          minute: time.get('minute'),
          second: time.get('second')
        });
       }
    }


  if (this.moment(params.current).isBefore(this.moment().add(daysNumber, 'days'), 'day')) {
    return false
  }
  /* if scheduled date is today (daysNumber is 0) we allow it only if it is before closing hours */
  if (daysNumber > 0 && this.moment(params.current).isSame(this.moment().add(daysNumber, 'days'), 'day')) {
    /*  if today is the first date when it is allowed to schedule a service for the checked date, check bookNotLaterThanTime */

    if (bookNotLaterThanTime){
      const currentMoment = this.moment()
       if (currentMoment.isAfter(bookNotLaterThanTime, 'minute')) {
        return false
      }
    }
  }
   if (params.user !== 'administrator') {
    let maximumNumberDays = this.orderData[this.state.ServiceType].maximumDaysNumberToAllowBooking
    if (this.moment(params.current).isAfter(this.moment().add(maximumNumberDays, 'days'), 'day')) { /* allow to schedule services not later than specific number of days */
      return false
    }
  }


    const TimeWindow = params.updatedTimeWindow ? params.updatedTimeWindow : this.state.TimeWindow
    const serviceAreas = params.filterServiceAreas ? this.filteredServiceAreasForLocation : this.state.serviceAreasForLocation

    if (_.get(this.state,[this.state.ServiceType+'DateRules'], []).length > 0) {
        if (_.includes(this.state[this.state.ServiceType+'DateRules'], params.current.format('MM-DD-YYYY'))) {
            return false;
        }
    }

      if (this.state.ServiceType == 'Pickup') {
        if (_.size(serviceAreas)) {
            /* check if date is available for at least one area */
            var dateIsAvailable = false, areasToRemove = []
            _.forEach(serviceAreas, function (serviceArea) {
                if (_.includes(serviceArea.DaysOfWeek, params.current.day() + 1)) {/* moment().day() return days of week Sunday as 0 and Saturday as 6*/
                    dateIsAvailable = true;
                } else if (params.filterServiceAreas) { /* service areas are filtered only schedule service pages for sellers */
                    areasToRemove.push(serviceArea)
                 }
            }.bind(this))
            if (_.size(areasToRemove)) {
                _.pullAll(serviceAreas, areasToRemove)
            }

            if (!dateIsAvailable) {
                return false;
            }

             if (TimeWindow) {  /*  check if existing pickups size for selected slot is less than maximum time slot size*/

                var dateIsAvailable = false;

                _.forEach(serviceAreas, function (serviceArea) {
                    var maximumSizeForTimeSlot = findMaximumPickupSize.call(this,{PickupDate:params.current,timeSlots: [TimeWindow],serviceAreaToCheck:serviceArea,user:params.user})
            //   console.log('maximumSizeForTimeSlot for date', maximumSizeForTimeSlot,this.state.Size  );
                 //   if (this.moment(params.current).format('MM-DD') == '07-30') {
                        // console.log('in check dates maximumSizeForTimeSlot',TimeWindow.value,  maximumSizeForTimeSlot);
               //     }
                    if (maximumSizeForTimeSlot == -100 || maximumSizeForTimeSlot > 0) {
                        /* enable only if selected time slot and date is available in this area  */
                        var serviceTimeFound = _.find(serviceArea.ServiceTimes, function (serviceTime) {
                            return TimeWindow.value == serviceTime.value
                        }.bind(this))
                        if (serviceTimeFound && _.includes(serviceArea.DaysOfWeek, params.current.day() + 1)) {
                            if (!this.state.Size || maximumSizeForTimeSlot == -100 || this.state.Size <= maximumSizeForTimeSlot) {  /* check if date is available for PickupSize, if it is selected */
                                dateIsAvailable = true
                            }
                            if (params.filterServiceAreas){
                               if( this.state.Size && maximumSizeForTimeSlot >0 &&  this.state.Size > maximumSizeForTimeSlot){
                                   areasToRemove.push(serviceArea)
                               }
                            }
                        }
                    }
                }.bind(this))

                if (!dateIsAvailable) {
                    return false;
                }
            } else {  /* check maximum available pickup size for any time slot and compare it with Size option, if it is selected*/
                var maximumSizeForAnyTimeSlot = findMaximumPickupSize.call(this, {
                    // filterServiceAreas:true,
                    PickupDate:params.current, timeSlots:this.orderData[this.state.ServiceType].timeWindowOptions,user:params.user})
                    //   console.log('maximumSizeForAnyTimeSlot', maximumSizeForAnyTimeSlot);
                if (this.state.Size) {  /* check if time slot available for selected PickupSize */
                    if ( maximumSizeForAnyTimeSlot !== -100 && this.state.Size > maximumSizeForAnyTimeSlot) {
                        return false;
                    }
                } else {
                    if (maximumSizeForAnyTimeSlot !== -100 && maximumSizeForAnyTimeSlot <= 0) {
                        return false;
                    }
                }
            }
             if (_.size(areasToRemove)) {
                _.pullAll(serviceAreas, areasToRemove)
            }
        }

    } else { /* this is Drop-off*/
        let currentTimeWindow

        if (TimeWindow) {  /* check if selected time slot is available for this date*/
            currentTimeWindow = TimeWindow
            if (!_.includes(TimeWindow.DaysOfWeek, params.current.day() + 1)) {
                return false
            }
        } else {/* applied when service time is not yet selected*/
            const timeWindowOptions =  this.orderData[this.state.ServiceType].timeWindowOptions.filter(item => !item.disabled )
            /* If there are multiple time windows, sort in descending order by closing time */
            const availableTimeSlot = timeWindowOptions.sort((a, b) => {
                const aClosingHour = a.value.split('_')[1]
                const bClosingHour = b.value.split('_')[1]
                return -1 * aClosingHour.localeCompare(bClosingHour)
            }).find(timeSlotData => {
                return  timeSlotData.DaysOfWeek.includes(params.current.day() + 1)
            })

            currentTimeWindow = availableTimeSlot
             if (!availableTimeSlot || !_.includes(this.orderData.Dropoff.DaysOfWeek, params.current.day() + 1)) {
                return false
            }
        }

        if (params.current.format('MM-DD-YYYY') === this.moment().format('MM-DD-YYYY')) {
            const allowedHour = currentTimeWindow.value.split('_')[1]
            const allowedDate = this.moment()

            allowedDate.set({
                hour: allowedHour,
                minute: 0,
                second: 0,
                millisecond: 0
            })

            if (this.moment().isAfter(allowedDate.add(-30, 'minutes'))) {
                return false
            }
        }

          let maximumSizeForAnyTimeSlot = findMaximumDropoffSize.call(this, {
              PickupDate:params.current,  user:params.user})

          if (this.state.Size) {  /* check if time slot available for selected PickupSize */
              if (maximumSizeForAnyTimeSlot !== -100 && this.state.Size > maximumSizeForAnyTimeSlot) {
                  return false
              }
          } else {
              if (maximumSizeForAnyTimeSlot !== -100 && maximumSizeForAnyTimeSlot <= 0) {
                  return false
              }
          }
    }

    return true
}
export function handleFrameTasks(params){
    if (config.getEnvironmentName() !== 'local') {
      //  console.log('handleFrameTasks params', params);
    }
     if (_.get(params.event, 'origin', '').indexOf('https://good-buy-gear.myshopify.com') == 0 || _.get(params.event, 'origin', '').indexOf('https://goodbuygear.com') == 0) {
        if (_.get(params.event, 'data.eventName') == 'triggerSetIframeHeightAction' && _.get(params.event, 'data.elementID') ==params.elementID) {
            sendDataForIframe.call(this,  params.elementID)
        } else   if (_.get(params.event, 'data.eventName') == 'displayNotificationFromShopify'){
            if (_.get(params.event, 'data.messageText')) {
                params.displayMessage({
                    'messageType': _.get(params.event, 'data.messageType'),
                    'messageCode': _.get(params.event, 'data.messageText')
                })
            }
        }
        // else if (_.get(params.event, 'data.eventName') =='customerSignedIn' ){
        //     params.callback.call(this )
        // }
    } else {

         if (config.getEnvironmentName() !== 'local') {
            // console.log('event sent from another website');

         }
     //    if (config.getEnvironmentName() == 'local') {
     //        if (_.get(params.event, 'data.eventName') == 'customerSignedIn') {
     //            params.callback.call(this, params.event.data)
     //        }
     //    }
    }
}
export function sendDataForIframe(elementID, params={}) {
    if (config.getEnvironmentName() == 'local') {
       return;
    }
    console.log('sendDataForIframe', params);
    if (window.parent) {
        window.parent.postMessage({
            'eventName': 'setIframeHeight',
            'elementID': elementID,
            height:_.get(params,  'height',_.get(this.pageContent, 'clientHeight', 100))
            //  scrollToIframe: scrollToIframe
        }, "*");
    }
}

export function findMaximumPickupSize(params ) { /* get maximum pickup size for passed time slots */

    var self = this
      params = _.defaults(params, {timeSlots: [], serviceAreaToCheck: false, user:'user'})
     var maximumPickupSize = -100
       _.forEach(self.filteredServiceAreasForLocation, function (serviceArea) {
        if (params.serviceAreaToCheck && params.serviceAreaToCheck._id !== serviceArea._id) { /* check maximumPickupSize only for specific area */
            return true;
        }
       // var pickupsForDateAndArea = _.get(self.state.ScheduledPickups, [self.moment(params.PickupDate).format('MM-DD'), serviceArea._id], [])

        // if (self.moment(params.PickupDate).format('MM-DD') == '02-21'){
        //     console.log('pickupsForDateAndArea', pickupsForDateAndArea  );
        // }

            var pickupsForDateAndMarket =[]
           _.forOwn(self.state.ScheduledPickups, (scheduledPickupsForDate, date)=>{/* filter scheduled pickups linked to a service area from the selected market*/
                      if(self.moment(params.PickupDate).format('MM-DD') == date){
                         _.forEach(scheduledPickupsForDate, (scheduledPickupsForServiceArea, serviceAreaID)=>{
                             var serviceAreaForCurrentMarket = _.find(self.state.serviceAreasByMarket[self.state.CurrentLocation], (serviceArea)=>{
                               if (serviceArea._id == serviceAreaID){
                                   return true
                               }
                            })
                            if (serviceAreaForCurrentMarket){
                                pickupsForDateAndMarket =  pickupsForDateAndMarket.concat(scheduledPickupsForServiceArea)
                            }
                        })
                    }
           })

        //  var PickupsByTimeSlotsAndAreas = _.groupBy(pickupsForDateAndArea, function (scheduledPickup) {
        //     return scheduledPickup.TimeWindow
        // })
          var PickupsByTimeSlotsAndMarket = _.groupBy(pickupsForDateAndMarket, function (scheduledPickup) {
              return scheduledPickup.TimeWindow
          })
           //console.log('PickupsByTimeSlotsAndMarket', PickupsByTimeSlotsAndMarket  );
         _.forOwn(params.timeSlots, function (timeSlot) {
             if (timeSlot.disabled) {
                 return true
             }
            var totalSizeForTimeSlotAndMarket = 0
            if (PickupsByTimeSlotsAndMarket[timeSlot.value]) {
                totalSizeForTimeSlotAndMarket = _.sumBy(PickupsByTimeSlotsAndMarket[timeSlot.value], function (o) {
                    return o.Size;
                });
            }
            const maximumNumberForDay = self.orderData['Pickup'].SettingsData.maximumSizeNumberForDay
                .find((item) => item.dayOfWeek.toLowerCase() === self.moment(params.PickupDate).format('dddd').toLowerCase())

            if (maximumNumberForDay && (maximumPickupSize < (maximumNumberForDay.value - totalSizeForTimeSlotAndMarket))) {
                maximumPickupSize = (maximumNumberForDay.value - totalSizeForTimeSlotAndMarket)
             }
        })
           // if (maximumPickupSize <= 0){/* if maximum  available pickup size is 0 for passed time slots, this service area is not available */
          //     serviceArea.available = false;
          // }
          // console.log('pickupsForDateAndMarket', pickupsForDateAndMarket  );
           var totalSizeForDayAndMarket = _.sumBy(pickupsForDateAndMarket, function (o) {
               return o.Size;
           });

                    var maximumSizeNumberForDate = _.find(_.get(self.orderData['Pickup'].SettingsData, 'maximumSizeNumberForDayByDates', []), function (rule) {
                   return self.moment(rule.Date).isSame(self.moment(params.PickupDate), 'day')
               })



               var maximumSizeNumberForDay = maximumSizeNumberForDate ? maximumSizeNumberForDate.value : _.get(_.find(_.get(self.orderData['Pickup'].SettingsData, 'maximumSizeNumberForDay', []), item => {
                   return _.get(item, 'dayOfWeek') == self.moment(params.PickupDate).format('dddd')
               }), 'value', 12)

            var pickupSizeAvailableForDay =maximumSizeNumberForDay- totalSizeForDayAndMarket
             if (pickupSizeAvailableForDay >0) { /* maximum pickup size for day override maximum size for time slots*/
               if (pickupSizeAvailableForDay <  maximumPickupSize){
                   maximumPickupSize = pickupSizeAvailableForDay
                }
           }else{
               maximumPickupSize =0
           }
    }.bind(this))


    return maximumPickupSize
}
export function findMaximumDropoffSize(params ) { 
     var self = this
    params = _.defaults(params, { user:'user'})
    var maximumDropoffSize = -100

        var dropoffsForDateAndMarket =[]
        _.forOwn(self.state.ScheduledDropoffs, (scheduledDropoffsForDate, date)=>{
             if(self.moment(params.PickupDate).format('MM-DD') == date){

                         dropoffsForDateAndMarket =  dropoffsForDateAndMarket.concat(scheduledDropoffsForDate)

 
            }
        })



     var totalSizeForDayAndMarket = _.sumBy(dropoffsForDateAndMarket, function (o) {
        return o.Size;
    });
    // console.log('totalSizeForDayAndMarket', totalSizeForDayAndMarket  );


    var maximumSizeNumberForDate = _.find(_.get(self.orderData['Dropoff'].SettingsData, 'maximumSizeNumberForDayByDates', []), function (rule) {
        return self.moment(rule.Date).isSame(self.moment(params.PickupDate),'day')
    })

  var   maximumSizeNumberForDay  = maximumSizeNumberForDate? maximumSizeNumberForDate.value:_.get(_.find(_.get(self.orderData['Dropoff'].SettingsData, 'maximumSizeNumberForDay', []), item=>{
        return  _.get(item,'dayOfWeek') ==self.moment(params.PickupDate).format('dddd')
    }), 'value',12)
          var dropoffSizeAvailableForDay = maximumSizeNumberForDay- totalSizeForDayAndMarket
         if (dropoffSizeAvailableForDay >0) { /* maximum pickup size for day override maximum size for time slots*/

                maximumDropoffSize = dropoffSizeAvailableForDay

        }else{
            maximumDropoffSize =0
        }
    

 
    return maximumDropoffSize
}

export function  updateSelectedServiceData(params ={user:'user'}) {
    console.log('updateSelectedServiceData', this.state.ServiceType  );
    const self = this;
     if (this.state.ServiceType == ''){ /* if Service Type is not yet selected */
        return;
    }
     resetServiceData.call(this)


    var updateData = {}, updatedPickupDate = _.clone(this.state.PickupDate),
        updatedTimeWindow = _.clone(this.state.TimeWindow)
    /*  get  updated PickupDate as prepareTimeWindowOptions and prepareSizeOptions depends on its value*/

    if (this.state.PickupDate && !checkValidDates.call(this,
            {current: this.moment(this.state.PickupDate), filterServiceAreas: false,...params})) {
        updatedPickupDate = false;
    }
    if(  this.state.administratorMode){
        console.log('in administratorMode',this.state.administratorMode   );
        return
    }
     if (updatedPickupDate) {
        checkValidDates.call(this,{
            current:  this.moment(updatedPickupDate),
            filterServiceAreas: true, ...params})
        /* filter service areas */
    }
      prepareTimeWindowOptions.call(this, {PickupDate:updatedPickupDate })
    if (this.state.TimeWindow) {
        var selectedTimeWindow = _.find(this.orderData[this.state.ServiceType].timeWindowOptions, {value: this.state.TimeWindow.value})
        if (selectedTimeWindow.disabled) {
            updatedTimeWindow = false;
            updateData.TimeWindow = false
        }
      const serviceAreasWithSelectedTimeWindow = this.filteredServiceAreasForLocation.filter(function (serviceArea) {
        return serviceArea.ServiceTimes.find(function (serviceTime) {
          return self.state.TimeWindow.value == serviceTime.value
        })
      })
      this.filteredServiceAreasForLocation = serviceAreasWithSelectedTimeWindow

    }
    if (updatedPickupDate) {
        checkValidDates.call(this,{
            current:this.moment(updatedPickupDate),
            updatedTimeWindow: updatedTimeWindow,
            filterServiceAreas: true,...params
        })
    }
    // if (this.state.ServiceType == 'Pickup') {
    //     prepareSizeOptions.call(this, updatedPickupDate, updatedTimeWindow)
    //     var selectedSize = _.find(config.services[this.state.ServiceType.toLowerCase()].sizeOptions, {value: this.state.Size})
    //     if (selectedSize && selectedSize.disabled) {
    //         updateData.Size = false
    //     }
    // }
    this.setState(updateData, function () {
       if (params.callback){
           params.callback()
       }
    })
}
export function resetServiceData() {
    this.orderData = _.cloneDeep(this.orderDataOriginal)
        this.filteredServiceAreasForLocation = _.map(this.state.serviceAreasForLocation, serviceArea => {
            return {
                _id: serviceArea._id,
                Name: serviceArea.Name,
                DaysOfWeek: serviceArea.DaysOfWeek,
                ServiceTimes: serviceArea.ServiceTimes,
                selectedDateAvailable: true,
                selectedTimeWindowAvailable: true, selectedSizeAvailable: true
            }
        });

};
export function  prepareTimeWindowOptions(params) {
   console.log('prepareTimeWindowOptions', params  );
     params = _.defaults(params, {timeWindowOptions: false, filterServiceAreas: false, user: 'user'})
     var timeSlotsToCheck = params.timeWindowOptions ? params.timeWindowOptions : this.orderData[this.state.ServiceType].timeWindowOptions;
    if (this.state.ServiceType == 'Pickup') {
        /* check time slots available for selected service areas */
         _.forEach(timeSlotsToCheck, function (option) {
          const optionIsAvailable = this.filteredServiceAreasForLocation.find(function (serviceArea) {
                /* check if at least for one service area time slot is available */
                return serviceArea.ServiceTimes.find(function (serviceTime) {
                  return option.value == serviceTime.value
                })
             })
            if (!optionIsAvailable) {
                option.disabled = true;
            }
        }.bind(this))
         if (params.PickupDate) {/* check if time slots are available for selected date and  service areas */
            _.forEach(_.filter(timeSlotsToCheck, {disabled: false}), function (timeWindowOption) {
                 var maximumSizeForTimeSlot = findMaximumPickupSize.call(this,{PickupDate:params.PickupDate,timeSlots: [timeWindowOption]})

                if (this.state.Size) {  /* check if time slot available for selected PickupSize */
                    if (maximumSizeForTimeSlot !== -100 && this.state.Size > maximumSizeForTimeSlot) {
                        timeWindowOption.disabled = true;
                    }
                } else {
                    if (maximumSizeForTimeSlot !== -100 && maximumSizeForTimeSlot <= 0) {
                        timeWindowOption.disabled = true;
                    }
                }
            }.bind(this))
        }
    } else { /* for Dropoff */
        _.forEach(_.filter(timeSlotsToCheck, {disabled: false}), function (timeWindowOption) {
            if (params.PickupDate) {/* check time slots for selected date */
                if (!_.includes(timeWindowOption.DaysOfWeek, params.PickupDate.day() + 1)) {
                    timeWindowOption.disabled = true;
                }
           }

        }.bind(this))

    }
 }
export function   prepareSizeOptions(updatedPickupDate, updatedTimeWindow) {
  //  console.log('in prepare size options' ,updatedPickupDate );
     _.forEach( config.services[this.state.ServiceType.toLowerCase()].sizeOptions, function (pickupSizeOption) {
        if (updatedPickupDate) {
            if (updatedTimeWindow) { /* check maximum pickup size for selected time slot  */
                var maximumSizeForTimeSlot =  findMaximumPickupSize.call(this,{PickupDate:updatedPickupDate,timeSlots: [updatedTimeWindow]})


                if (maximumSizeForTimeSlot !== -100 && pickupSizeOption.value > maximumSizeForTimeSlot) {
                    pickupSizeOption.disabled = true;
                }
            } else { /* check maximum pickup size for any time slot during the selected date */
                var maximumSizeForAnyTimeSlot = findMaximumPickupSize.call(this,{PickupDate:updatedPickupDate,timeSlots: this.orderData[this.state.ServiceType].timeWindowOptions})
           //console.log('maximumSizeForAnyTimeSlot', maximumSizeForAnyTimeSlot  );
               // console.log('maximumSizeForAnyTimeSlot', maximumSizeForAnyTimeSlot);
                if (maximumSizeForAnyTimeSlot !== -100 && pickupSizeOption.value > maximumSizeForAnyTimeSlot) {
                    pickupSizeOption.disabled = true;
                }
            }

        } else {
            pickupSizeOption.disabled = false;
        }

    }.bind(this))

}

export function customSelectValue(options) {
    return <div className="custom-select-value">
        <div className="Select-placeholder">{options.placeholder}</div>
        <div className="Select-value"><span className="Select-value-label" role="option"
                                            aria-selected="true">{options.value.label}</span></div>
    </div>;
}

export function removeInvalidAgeGroups(ageGroups) {
    if(!_.isArray(ageGroups)){
      return []
    }
    return ageGroups.filter(item =>
        getAllowedAgeGroups().find(ageGroup => ageGroup.value === item)
    )
}

export function getAllowedAgeGroups() {
    return config.ageGroups.filter(item => item.allowed)
}
export function unformatPhoneNumber(PhoneNumberText){
  if(!PhoneNumberText){
    PhoneNumberText = ''
  }
  let PhoneNumber =  PhoneNumberText.replace(/[^0-9.]/g, "")
  if (PhoneNumber.indexOf('1') === 0) { /* remove country code 1 from the phone number */
    PhoneNumber = PhoneNumber.substring(1);
  }
  return PhoneNumber
}

export function displayVariationsSortingToggle(currentSort, callback) {
  return <div>
    <span className="pull-left top2 right10 font-size-18">{currentSort == 'asc' ? 'Sort Z-A' : 'Sort A-Z'}</span>
    <Switch className="pull-right" onColor={'#58c9c1'} onChange={()=>{
      callback();
    }} checked={currentSort == 'asc'} />
  </div>;
}